import React from 'react'
import './DescriptionBox.css'
const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">Description</div>
        <div className="descriptionbox-nav-box fade">Reviws(122)</div>
      </div>
      <div className="descriptionbox-description">
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deleniti voluptates pariatur consequuntur repellendus temporibus totam commodi itaque debitis distinctio voluptatem earum harum dolorem veniam iste eos repellat quo nisi asperiores corrupti qui fugiat, aspernatur error. Ad illum praesentium blanditiis ut impedit officia porro nisi eum corrupti corporis laudantium reprehenderit, tenetur consequatur quae libero harum suscipit quas at possimus quaerat dolore! Laborum quae sint obcaecati quibusdam, dolore expedita illum voluptatum corporis voluptas quaerat doloribus accusantium dolor eius cupiditate! Atque quaerat aliquid similique perspiciatis.

        </p>
        <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut nobis ipsa, exercitationem dolor earum ea accusamus voluptates possimus repudiandae adipisci mollitia iste culpa, optio quasi at velit molestiae quia nulla!
            Placeat, illo! Voluptatem quibusdam quod quas tempora illo similique repellat sed saepe id esse animi perferendis aspernatur laboriosam doloribus consectetur, magni eum molestiae eos. Vero quia reiciendis corrupti vel asperiores.
            Aperiam nihil corporis veniam eligendi ducimus. Numquam ratione ipsum nobis facilis qui fuga corporis quidem, est, quia hic voluptas distinctio non error at inventore tenetur ab ex dolorum obcaecati rem!
        </p>
      </div>
    </div>
  )
}

export default DescriptionBox
